import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ScheduleSRPortal } from '../ScheduleSRPortal';
import {
  ACCESS_TOKEN_COOKIE,
  ID_TOKEN_COOKIE,
  envUrl,
  envUrlSRPortal,
  routes,
} from '../../config';
import cookieService from '../../services/cookieService';
import providerService from '../../services/providerService';
import headerCancelModal from '../../actions/headerCancelModalAction';

const srPortalConfig = {
  enabled: true,
  scheduleSRPortalScriptPath: `${envUrlSRPortal}/static/chunks/remoteEntry.js`,
  apiBaseUrl: envUrlSRPortal,
};

const PROGRAMMING_FILE_EXPANDED_SECTIONS = ['programmingFileDetails'];
const PROGRAMMING_FILE_SOURCE = 'programming-file-requests';

const ViewServiceRequest = ({ country, lang }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const locationState = location.state;

  const modalTrigger = useSelector(
    (payload) => payload.headerCancelModal,
  );

  const accessToken = cookieService.getCookie(ACCESS_TOKEN_COOKIE);
  const idToken = cookieService.getCookie(ID_TOKEN_COOKIE);
  const { providerId } = providerService.getProviderDetails();
  const logoutUrl = `${envUrl}${routes.dpx.logout}`;

  const returnPath =
    locationState?.returnPath ||
    `/${country}/${lang}/${routes.dpx.home}`;
  const expandedSections =
    locationState?.source === PROGRAMMING_FILE_SOURCE
      ? PROGRAMMING_FILE_EXPANDED_SECTIONS
      : undefined;

  // Handle header cancel (x) button click
  useEffect(() => {
    if (modalTrigger) {
      dispatch(headerCancelModal(false));
      history.push(returnPath);
    }
  }, [modalTrigger]);

  // Guard: redirect back if no state was passed (e.g. direct URL access or page refresh)
  useEffect(() => {
    if (!locationState?.serviceRequestId) {
      history.replace(`/${country}/${lang}/${routes.dpx.home}`);
    }
  }, []);

  if (!locationState?.serviceRequestId) {
    return null;
  }

  const {
    serviceRequestId,
    serviceRequestNumber,
    patientId,
    csrId,
    patientDetails,
  } = locationState;

  return (
    <div id="main-content">
      <div className="ccl__dpx_center-1024">
        <ScheduleSRPortal
          config={srPortalConfig}
          accessToken={accessToken}
          idToken={idToken}
          selectedProviderId={providerId}
          pageType="ServiceRequestDetails"
          logoutUrl={logoutUrl}
          serviceRequestId={serviceRequestId}
          serviceRequestNumber={serviceRequestNumber}
          patientId={patientId}
          patientDetails={patientDetails}
          clinicalServiceRequestId={csrId}
          hideInternalNavigation
          returnPath={returnPath}
          expandedSections={expandedSections}
          onClose={() => history.push(returnPath)}
        />
      </div>
    </div>
  );
};

export default ViewServiceRequest;
